import { render, staticRenderFns } from "./CardSoftwareDiagnostico.vue?vue&type=template&id=792d1508&scoped=true&"
import script from "./CardSoftwareDiagnostico.vue?vue&type=script&lang=js&"
export * from "./CardSoftwareDiagnostico.vue?vue&type=script&lang=js&"
import style0 from "./CardSoftwareDiagnostico.vue?vue&type=style&index=0&id=792d1508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d1508",
  null
  
)

export default component.exports